import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {errorMessages} from '../../core/error/errorMessages';
import {ReportAccountComponentDataServiceAdapter} from './impl/service/ngrx/reportAccountComponentDataService.adapter';
import {ReportAccountComponentRepository} from './impl/service/ngrx/reportAccountComponent.repository';
import {ReportAccountComponentDataService} from './impl/service/ngrx/reportAccountComponentData.service';
import {ReportAccountComponentConverter} from './api/entity/converter/reportAccountComponent.converter';

@NgModule({
    providers: [
        ReportAccountComponentConverter,
        ReportAccountComponentDataService,
        ReportAccountComponentRepository,
        ReportAccountComponentDataServiceAdapter,
    ],
    imports: []
})
export class ReportingAccountComponentModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: ReportAccountComponentRepository,
                dataService: ReportAccountComponentDataService,
    ) {

        entityDataService.registerServices({
            ReportAccountComponent: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ReportAccountComponent: repository,
        });

        errorMessages
            .set('REPORT_COMPONENT_SAVE_MAXIMUM_COMPONENT_COUNT_REACHED', 'Vous avez atteint votre quota pour ce type de composant');
    }
}
